// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-border {
  position: relative;
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
}

input[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.aa-language-item:has(input:disabled) {
  opacity: 0.5;
  cursor: not-allowed;
}

.agentassist-widget-main-chat-container-wrapper {
  height: 100%;
  display: flex;
  position: relative;
}
.agentassist-widget-main-chat-container-wrapper.left-menu-nav-enable {
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  border-radius: 4px;
}
.agentassist-widget-main-chat-container-wrapper.left-menu-nav-enable .section-agent-aa-wrapper {
  box-shadow: none;
}
.agentassist-widget-main-chat-container-wrapper nav {
  flex-shrink: 0;
  border-radius: 4px 0px 0px 4px;
  border-right: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  display: flex;
  padding: 11px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 72px;
}
.agentassist-widget-main-chat-container-wrapper .section-agent-aa-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
}
.agentassist-widget-main-chat-container-wrapper .section-agent-aa-wrapper header {
  border-radius: 4px 4px 0px 0px;
  border-bottom: 1px solid var(--AA-gloabl-border);
  background: var(--AA-gloabl-bg-secondary);
}
.agentassist-widget-main-chat-container-wrapper .section-agent-aa-wrapper .body-container-aa {
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
}
.agentassist-widget-main-chat-container-wrapper .section-agent-aa-wrapper footer {
  border-radius: 0px 0px 4px 4px;
  background: var(--AA-gloabl-bg-secondary);
}

.aa-no-tabs-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  padding: 0 16px;
}

@-webkit-keyframes NudgeslideInDown {
  0% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes NudgeslideInDown {
  0% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.nudges-wrapper-fixed {
  position: absolute;
  width: 100%;
  height: auto;
  z-index: 9999;
  max-width: 418px;
  margin: 0 auto;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 40px;
  padding: 10px 16px;
  -webkit-animation-name: NudgeslideInDown;
  animation-name: NudgeslideInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.nudges-wrapper-fixed .nudges-template-data {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card {
  border-radius: 24px;
  background: var(--success-500-main, #22C55E);
  box-shadow: 15px 15px 26px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  padding: 6px 16px;
  gap: 6px;
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card.info-nudge {
  background: var(--AA-gloabl-border);
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card.info-nudge p {
  color: var(--AA-gloabl-text-color);
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card.info-nudge .close-nudge svg path {
  stroke: #000000;
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card.warning-nudge {
  background: var(--warning-500-main, #F59E0B);
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card.danger-nudge {
  background: var(--destructive-500-main, #EF4444);
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card .icon_block {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--AA-global-white-color);
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card .icon_block svg path {
  fill: #FFFFFF;
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card p {
  color: var(--AA-global-white-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  width: 100%;
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card .close-nudge {
  width: 16px;
  height: 16px;
  background: transparent;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--AA-global-white-color);
  font-size: 16px;
}
.nudges-wrapper-fixed .nudges-template-data .nudges-card .close-nudge svg path {
  stroke: #FFFFFF;
}

.widgets-disabled-card-wrapper {
  position: absolute;
  bottom: 0;
  padding: 20px 10px;
  z-index: 9;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.widgets-disabled-card-wrapper .widgets-info-disabled-content {
  border-radius: 12px;
  background: var(--Warning-500, #F79009);
  box-shadow: 0px 25px 50px -12px rgba(16, 24, 40, 0.25);
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 16px;
}
.widgets-disabled-card-wrapper .widgets-info-disabled-content .icon_block {
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 28px;
  border: 2px solid var(--Warning-100, #FEF0C7);
  background: var(--Base-White, #FFF);
  color: #F79009;
  font-size: 16px;
}
.widgets-disabled-card-wrapper .widgets-info-disabled-content .content-info-widget {
  width: 100%;
}
.widgets-disabled-card-wrapper .widgets-info-disabled-content .content-info-widget h1 {
  color: var(--Base-White, #FFF);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin: 0 0 4px 0;
}
.widgets-disabled-card-wrapper .widgets-info-disabled-content .content-info-widget p {
  color: var(--Base-White, #FFF);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
}

@-webkit-keyframes HintslideInUp {
  0% {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@keyframes HintslideInUp {
  0% {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@-webkit-keyframes shakeHint {
  0%, 100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}
@keyframes shakeHint {
  0%, 100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}
.hints-wrapper-fixed {
  position: absolute;
  width: 100%;
  height: auto;
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  bottom: 56px;
  overflow: auto;
  max-height: 80%;
  max-width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  -webkit-animation-name: HintslideInUp;
  animation-name: HintslideInUp;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.hints-wrapper-fixed .hints-template-data {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: auto;
  height: 100%;
  max-height: 500px;
  padding: 10px 16px;
}
.hints-wrapper-fixed .hints-template-data .hint-card {
  border-radius: 12px;
  background: var(--success-600, #16A34A);
  box-shadow: 0px 25px 50px -12px rgba(16, 24, 40, 0.25);
  position: relative;
  padding: 12px;
  -webkit-animation-name: shakeHint;
  animation-name: shakeHint;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  animation-delay: 1s;
  -webkit-animation-delay: 1s;
}
.hints-wrapper-fixed .hints-template-data .hint-card.info-hint {
  background: var(--gray-neutral-500, #6C737F);
}
.hints-wrapper-fixed .hints-template-data .hint-card.info-hint .top-card-info .icon_block {
  border: 2px solid var(--Neutral-200, #E5E5E5);
}
.hints-wrapper-fixed .hints-template-data .hint-card.info-hint .top-card-info .icon_block svg path {
  fill: #667085;
}
.hints-wrapper-fixed .hints-template-data .hint-card.warning-hint {
  background: var(--warning-500, #F79009);
}
.hints-wrapper-fixed .hints-template-data .hint-card.warning-hint .top-card-info .icon_block {
  border: 2px solid var(--Warning-100, #FEF0C7);
}
.hints-wrapper-fixed .hints-template-data .hint-card.warning-hint .top-card-info .icon_block svg path {
  fill: #F79009;
}
.hints-wrapper-fixed .hints-template-data .hint-card.danger-hint {
  background: var(--destructive-500-main, #EF4444);
}
.hints-wrapper-fixed .hints-template-data .hint-card.danger-hint .top-card-info .icon_block {
  border: 2px solid var(--error-200, #FECDCA);
}
.hints-wrapper-fixed .hints-template-data .hint-card.danger-hint .top-card-info .icon_block svg path {
  stroke: #F04438;
}
.hints-wrapper-fixed .hints-template-data .hint-card .top-card-info {
  display: flex;
  align-items: center;
  gap: 6px;
}
.hints-wrapper-fixed .hints-template-data .hint-card .top-card-info .icon_block {
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  border: 2px solid var(--success-100, #D1FADF);
  background: #FFFFFF;
  flex-shrink: 0;
  color: #039855;
}
.hints-wrapper-fixed .hints-template-data .hint-card .top-card-info h1 {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  width: 100%;
}
.hints-wrapper-fixed .hints-template-data .hint-card .top-card-info .close-hint {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  background: transparent;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 20px;
}
.hints-wrapper-fixed .hints-template-data .hint-card .body-hint {
  padding: 6px 0;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
}
.hints-wrapper-fixed .hints-template-data .hint-card .footer-hint {
  text-align: right;
}
.hints-wrapper-fixed .hints-template-data .hint-card .footer-hint button {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

@-webkit-keyframes kr-spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes kr-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.loader-progress .loading-border {
  border: 3px solid var(--AA-gloabl-border);
  border-radius: 50%;
  border-top: 3px solid var(--AA-global-theme-bg);
  width: 40px;
  height: 40px;
  -webkit-animation: kr-spin 2s linear infinite;
  animation: kr-spin 2s linear infinite;
}
.loader-progress img {
  width: 30px;
  height: 30px;
}

.loader-progress-individual {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.loader-progress-individual .loading-border {
  border: 3px solid var(--AA-gloabl-border);
  border-radius: 50%;
  border-top: 3px solid var(--AA-global-theme-bg);
  width: 24px;
  height: 24px;
  -webkit-animation: kr-spin 2s linear infinite;
  animation: kr-spin 2s linear infinite;
}
.loader-progress-individual img {
  width: 24px;
  height: 24px;
}

.loader-progress-main {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  border: 0.5px solid var(--AA-gloabl-bg-secondary);
  border-radius: 5px;
}
.loader-progress-main .loading-border {
  border: 3px solid var(--AA-gloabl-border);
  border-radius: 50%;
  border-top: 3px solid var(--AA-global-theme-bg);
  width: 40px;
  height: 40px;
  -webkit-animation: kr-spin 2s linear infinite;
  animation: kr-spin 2s linear infinite;
}
.loader-progress-main img {
  width: 30px;
  height: 30px;
}

.summery-wrapper-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(52, 64, 84, 0.7);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.summery-wrapper-container .summery-popup-data {
  background: var(--AA-global-white-bg);
  border-radius: 6px;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 960px;
}
.summery-wrapper-container .summery-popup-data .title-block {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-bottom: 1px solid var(--AA-gloabl-border);
}
.summery-wrapper-container .summery-popup-data .title-block h1 {
  color: var(--AA-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  width: 100%;
}
.summery-wrapper-container .summery-popup-data .title-block svg path {
  fill: var(--AA-gloabl-text-color);
}
.summery-wrapper-container .summery-popup-data .title-block .ai-block {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--AA-gloabl-text-color);
  opacity: 0.6;
  gap: 10px;
}
.summery-wrapper-container .summery-popup-data .title-block .ai-block .close-summery {
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 16px;
  height: 16px;
  font-size: 16px;
  color: var(--AA-gloabl-text-color);
  cursor: pointer;
}
.summery-wrapper-container .summery-popup-data .title-block .ai-block .close-summery svg {
  width: 16px;
  height: 16px;
}
.summery-wrapper-container .summery-popup-data .title-block .ai-block .close-summery svg path {
  stroke: var(--AA-gloabl-text-color);
  fill: none;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion {
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item {
  border-radius: 8px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-gloabl-bg-secondary);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 100%;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item.new-summary-intent {
  flex-shrink: 0;
  height: 160px;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item.new-summary-intent .acc-summary-content-collapse {
  display: flex;
  flex-direction: column;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item.new-summary-intent .acc-summary-content-collapse .text-block-summary {
  height: 100%;
  position: relative;
  border-radius: var(--lg, 12px);
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  box-shadow: 0px 1px 2px 0px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 10px;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item.new-summary-intent .acc-summary-content-collapse .text-block-summary .input-control {
  height: 100%;
  border: 0;
  outline: 0 !important;
  box-shadow: none !important;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item.new-summary-intent .acc-summary-content-collapse .text-block-summary .recylin-bin-btn {
  border: 0;
  padding: 0;
  background: var(--AA-global-white-bg);
  cursor: pointer;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-btn {
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: transparent;
  border: 0;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-btn[aria-expanded=true] .summery-accordion-icon {
  transform: rotate(180deg);
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-btn span {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: var(--Primary-50, #EFF4FF);
  color: var(--Primary-700, #004EEB);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  flex-shrink: 0;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-btn .summery-accordion-icon {
  margin: 0 0 0 auto;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-content-collapse {
  padding: 8px;
  overflow: auto;
  flex: 1 1 auto;
  height: 100%;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-content-collapse .summery-accordion-content {
  height: 100%;
  overflow: hidden;
  border-radius: var(--lg, 12px);
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  box-shadow: 0px 1px 2px 0px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));
  padding: var(--sm, 6px) var(--default, 8px);
  position: relative;
  display: flex;
  flex-direction: column;
  padding-right: 0;
  position: relative;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-content-collapse .summery-accordion-content .aa-summary-text-input-new {
  height: 100%;
  width: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  resize: none;
  overflow: auto;
  color: var(--AA-gloabl-text-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  box-shadow: none;
  min-height: 120px;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-content-collapse .summery-accordion-content .summery-accordion-content-inner-sec {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  position: relative;
}
.summery-wrapper-container .summery-popup-data .summary-intent-block-data-accordion .summary-intent-block-data-accordion-item .acc-summary-content-collapse .summery-accordion-content .summery-accordion-content-inner-sec .summery-accordion-content-item {
  color: var(--AA-gloabl-text-color);
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
}
.summery-wrapper-container .summery-popup-data .actions-footer {
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: end;
  position: relative;
  min-height: 48px;
  border-top: 1px solid var(--AA-gloabl-border);
}
.summery-wrapper-container .summery-popup-data .actions-footer .footer-btns-left-sec {
  position: absolute;
  z-index: 99;
  left: 8px;
  top: 9px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.summery-wrapper-container .summery-popup-data .actions-footer .footer-btns-left-sec .refresh-btn {
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.summery-wrapper-container .summery-popup-data .actions-footer .footer-btns-left-sec .refresh-btn svg path {
  stroke: var(--AA-gloabl-text-color);
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info {
  padding: 0;
  background: transparent;
  width: 100%;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .dialog-ended-and-feedback {
  justify-content: flex-end;
  min-height: 30px;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .dialog-ended-and-feedback .line-border-content-info {
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .dialog-ended-and-feedback .line-border-content-info .line-border {
  background: var(--AA-global-theme-text-color);
  width: 100%;
  height: 1px;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .dialog-ended-and-feedback .line-border-content-info .date-time-text {
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  padding: 2px 8px;
  color: var(--AA-global-theme-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .icon_block {
  display: none;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info h1 {
  display: none;
}
.summery-wrapper-container .summery-popup-data .actions-footer .form-feedback-info .improve-feedback-block {
  margin-top: 6px;
}

.interputions-slider-terminate {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  background: rgba(52, 64, 84, 0.7);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  border-radius: 4px;
}
.interputions-slider-terminate .interputions-canvas {
  position: relative;
  overflow: auto;
  padding: 16px;
  background: var(--AA-global-white-bg);
  border-radius: 12px 12px 4px 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  -webkit-animation-name: HintslideInUp;
  animation-name: HintslideInUp;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  width: 100%;
  max-height: 60vh;
  overflow: auto;
}
.interputions-slider-terminate .interputions-canvas .aa_btn {
  margin-top: 6px;
}
.interputions-slider-terminate .interputions-canvas .close-btn {
  position: absolute;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 8px;
  top: 12px;
  z-index: 1;
  border: 0;
  background: transparent;
  padding: 0;
  opacity: 0.5;
}
.interputions-slider-terminate .interputions-canvas .close-btn svg path {
  fill: var(--AA-gloabl-text-color);
}
.interputions-slider-terminate .interputions-canvas .entity-mesage-data {
  padding: 7px 0px !important;
}

.multiple-options-popup {
  right: 0;
  bottom: 50px;
  background: var(--AA-global-white-bg);
  border: 1px solid var(--AA-gloabl-border);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 10;
  min-width: 128px;
}
.multiple-options-popup .aa-multiple-option-item {
  border: none;
  background: transparent;
  text-align: left;
  transition: background-color 0.2s ease;
}
.multiple-options-popup .aa-multiple-option-item:hover {
  background-color: var(--AA-gloabl-bg-secondary);
}

.feedback-popup-overlay {
  top: 0;
  left: 0;
  background: rgba(52, 64, 84, 0.7);
  backdrop-filter: blur(8px);
  z-index: 1000;
}
.feedback-popup-overlay .feedback-popup-container {
  background: var(--AA-global-white-bg);
  width: 376px;
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-close-btn {
  background: none;
  border: none;
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content {
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-gloabl-bg-secondary);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn {
  height: 30px;
  background: var(--AA-global-white-bg);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-satisfied-btn {
  border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-components-buttons-primary-success-button-primary-success-border, #75E0A7);
  color: var(--component-colors-components-buttons-primary-success-button-primary-success-fg_hover, #085D3A);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-satisfied-btn:hover {
  background: var(--component-colors-components-buttons-primary-success-button-primary-success-bg_hover, #ECFDF3);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-satisfied-btn.active {
  background: var(--colors-success-500, #17B26A);
  color: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-satisfied-btn.active svg path {
  stroke: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-unsatisfied-btn {
  border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-components-buttons-primary-error-button-secondary-error-border, #FDA29B);
  color: var(--component-colors-components-buttons-primary-error-button-secondary-error-fg, #B42318);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-unsatisfied-btn:hover {
  background: var(--component-colors-components-buttons-primary-error-button-secondary-error-bg_hover, #FEF3F2);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-unsatisfied-btn.active {
  background: var(--colors-error-500, #F04438);
  color: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-body .feedback-popup-body-content .feedback-option-btn.feedback-unsatisfied-btn.active svg path {
  stroke: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);
}
.feedback-popup-overlay .feedback-popup-container .feedback-popup-footer {
  border-top: 1px solid var(--AA-gloabl-border);
}

.attachment-info-wrapper {
  height: 100%;
  padding: 16px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  background: rgba(52, 64, 84, 0.7);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  border-radius: 4px;
}
.attachment-info-wrapper .attachment-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.attachment-info-wrapper .attachment-header .back-btn {
  padding: 0;
  width: 20px;
  flex-shrink: 0;
  background: transparent;
  border: 0;
  height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.attachment-info-wrapper .attachment-header .img-name {
  width: 100%;
  color: var(--AA-global-white-color);
}
.attachment-info-wrapper .attachment-body-img {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.attachment-info-wrapper .attachment-body-img img {
  width: 100%;
  object-fit: contain;
}

.toast-custom-msg-container.aa-network-error-toastr .toast-msg-custom {
  background: rgb(231, 130, 130) !important;
}

.toast-custom-msg-container {
  position: absolute;
  width: auto;
  height: auto;
  z-index: 9999;
  max-width: fit-content;
  margin: 0 auto;
  left: 0;
  right: 0;
  display: block;
  top: 45px;
  padding: 10px 16px;
  -webkit-animation-name: NudgeslideInDown;
  animation-name: NudgeslideInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.toast-custom-msg-container .toast-msg-custom {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--Kora-Green-Green-Medium, #93D3A2);
  background: var(--Kora-Green-Green-Light, #EAF6EC);
  padding: 4px 10px;
  gap: 10px;
  flex-shrink: 0;
  min-height: 28px;
}
.toast-custom-msg-container .toast-msg-custom .icon_block {
  line-height: 0;
  flex-shrink: 0;
}
.toast-custom-msg-container .toast-msg-custom .icon_block svg path {
  fill: #135423;
}
.toast-custom-msg-container .toast-msg-custom .toast-content-info {
  width: 100%;
  color: var(--Kora-Green-Green-Dark, #135423);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
}
.toast-custom-msg-container .toast-msg-custom .close-toast-msg {
  display: flex;
  align-items: center;
  width: 14px;
  height: 14px;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 14px;
  color: var(--Kora-Green-Green-Dark, #135423);
  flex-shrink: 0;
}

.aa-settings-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  background: rgba(52, 64, 84, 0.7);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  border-radius: 4px;
}
.aa-settings-wrapper .aa-settings-container {
  position: relative;
  overflow: hidden;
  background: var(--AA-global-white-bg);
  border-radius: 12px 12px 4px 4px;
  display: flex;
  flex-direction: column;
  -webkit-animation-name: HintslideInUp;
  animation-name: HintslideInUp;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  width: 100%;
  max-height: 80%;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-header {
  padding: 8px 12px;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-header .aa-settings-close-btn {
  border: 0;
  padding: 0;
  background: transparent;
  line-height: 0;
  flex-shrink: 0;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-header .aa-settings-close-btn svg path {
  fill: var(--AA-gloabl-text-color);
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body {
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  padding: 8px;
  background: var(--AA-gloabl-bg-secondary);
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-item {
  padding: 10px;
  background: var(--AA-global-white-bg);
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s all ease;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-item:hover {
  background: var(--AA-gloabl-bg-secondary);
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-item .card-icon {
  border-radius: 200px;
  background: var(--Primary-50, #EAF1FC);
  width: 28px;
  height: 28px;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-item .card-icon svg path {
  fill: var(--AA-global-theme-text-color);
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-item .aa-btn-link svg path {
  fill: var(--AA-gloabl-text-color);
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .proactive-mode-data .card-group {
  border-radius: 6px;
  border: 1px solid var(--AA-static-border);
  background: var(--AA-global-white-bg);
  width: 100%;
  padding: 10px 5px;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-group-help .card-item {
  border: 1px solid var(--AA-static-border);
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-group-help .card-item .card-icon {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-group-help .card-item .card-icon svg path {
  stroke: var(--AA-global-theme-text-color);
  fill: none;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .card-group-help .card-item .aa-btn-link svg path {
  stroke: var(--AA-gloabl-text-color);
  fill: none;
}
.aa-settings-wrapper .aa-settings-container .aa-settings-body .language-group {
  border: 1px solid var(--AA-static-border);
  border-radius: 6px;
  padding: 10px;
  background: var(--AA-global-white-bg);
  max-height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.generate-summary-action-minimized {
  position: fixed;
  z-index: 2;
  border-radius: 60px;
  background: var(--AAthemebgColorVariation-1, #F9FAFB);
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
  display: flex;
  padding: 10px;
  align-items: flex-start;
  gap: 2px;
  min-width: 45px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.generate-summary-action-minimized:hover {
  border-radius: 0px 60px 60px 60px;
  background: var(--Gray-300, #D0D5DD);
}
.generate-summary-action-minimized:hover svg {
  display: block;
}
.generate-summary-action-minimized .svg-inner {
  display: none;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
}
.generate-summary-action-minimized .svg-inner path {
  stroke: var(--whiteTextColor);
}
.generate-summary-action-minimized i {
  font-size: 18px;
  color: var(--primaryTextColor);
}
.generate-summary-action-minimized .status-summary-indicator {
  background: var(--warningTextColor, #F04438);
  width: 4px;
  height: 4px;
  border-radius: 100%;
  flex-shrink: 0;
}

.custom-tab-show-all-dialogs-popup-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  background: rgba(52, 64, 84, 0.7);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  border-radius: 4px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container {
  position: relative;
  overflow: hidden;
  background: var(--AA-global-white-bg);
  border-radius: 12px 12px 4px 4px;
  display: flex;
  flex-direction: column;
  -webkit-animation-name: HintslideInUp;
  animation-name: HintslideInUp;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  width: 100%;
  height: 60%;
  padding: 8px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-header {
  padding: 0 4px 4px 8px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-header .custom-tab-show-all-dialogs-popup-header-icon svg path {
  fill: var(--AA-global-theme-text-color);
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-header .custom-tab-show-all-dialogs-popup-close-btn {
  border: 0;
  padding: 0;
  background: transparent;
  line-height: 0;
  flex-shrink: 0;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-header .custom-tab-show-all-dialogs-popup-close-btn svg path {
  fill: var(--AA-gloabl-text-color);
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container {
  flex: 1 1 auto;
  height: 100%;
  padding: 8px 0;
  background: var(--AA-gloabl-bg-secondary);
  border-radius: 6px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container {
  padding: 0px 8px 0 8px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block {
  position: relative;
  background: var(--AA-global-white-bg);
  border-radius: 8px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .input-control {
  z-index: 1;
  position: relative;
  background: transparent;
  padding-right: 35px;
  padding-left: 35px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .input-control.suggestion-input {
  display: block;
  width: 100%;
  color: var(--AA-gloabl-text-color);
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .input-control.suggestion-input::-moz-selection { /* Code for Firefox */
  color: var(--AA-gloabl-text-color);
  background: transparent;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .input-control.suggestion-input::selection {
  color: var(--AA-gloabl-text-color);
  background: transparent;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block svg {
  cursor: pointer;
  position: absolute;
  left: 12px;
  top: 9px;
  z-index: 2;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block svg path {
  fill: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .clear-search {
  position: absolute;
  right: 12px;
  top: 8px;
  z-index: 2;
  cursor: pointer;
  background: border-box;
  border: 0;
  padding: 0;
  font-size: 16px;
  line-height: 0;
  color: var(--AA-gloabl-text-color);
  width: 16px;
  height: 16px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .clear-search svg {
  position: initial;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-dialog-search-container .input-block .clear-search svg path {
  stroke: var(--AA-gloabl-text-color);
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-tab-show-all-dialogs-popup-body {
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  padding: 8px 8px 0px 8px;
}
.custom-tab-show-all-dialogs-popup-wrapper .custom-tab-show-all-dialogs-popup-container .custom-tab-show-all-dialogs-popup-body-container .custom-tab-show-all-dialogs-popup-body .custom-dialog-list-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/base/aaContainer/aaContainer.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,mDAAA;AAAJ;;AAGA;EACI,YAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,mBAAA;AAAJ;;AAIA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AADJ;AAEI;EACI,mDAAA;EACA,kBAAA;AAAR;AACQ;EACI,gBAAA;AACZ;AAEI;EACI,cAAA;EACA,8BAAA;EACA,+CAAA;EACA,qCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAAR;AAEI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AAAR;AACQ;EACI,8BAAA;EACA,gDAAA;EACA,yCAAA;AACZ;AACQ;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AACZ;AACQ;EACI,8BAAA;EACA,yCAAA;AACZ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AADJ;;AAIA;EACI;IACI,oCAAA;IACA,4BAAA;IACA,mBAAA;EADN;EAGE;IACI,gCAAA;IACA,wBAAA;EADN;AACF;AAIA;EACI;IACI,oCAAA;IACA,4BAAA;IACA,mBAAA;EAFN;EAIE;IACI,gCAAA;IACA,wBAAA;EAFN;AACF;AAKA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAHJ;AAII;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAFR;AAGQ;EACI,mBAAA;EACA,4CAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;AADZ;AAEY;EACI,mCAAA;AAAhB;AACgB;EACI,kCAAA;AACpB;AAGwB;EACI,eAAA;AAD5B;AAMY;EACI,4CAAA;AAJhB;AAMY;EACI,gDAAA;AAJhB;AAMY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;AAJhB;AAMoB;EACI,aAAA;AAJxB;AAQY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AANhB;AAQY;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;AANhB;AAQoB;EACI,eAAA;AANxB;;AAcA;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAXJ;AAYI;EACI,mBAAA;EACA,uCAAA;EACA,sDAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAVR;AAWQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,6CAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;AATZ;AAWQ;EACI,WAAA;AATZ;AAUY;EACI,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AARhB;AAUY;EACI,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AARhB;;AAgBA;EACI;IACI,mCAAA;IACA,2BAAA;IACA,mBAAA;EAbN;EAeE;IACI,gCAAA;IACA,wBAAA;EAbN;AACF;AAgBA;EACI;IACI,mCAAA;IACA,2BAAA;IACA,mBAAA;EAdN;EAgBE;IACI,gCAAA;IACA,wBAAA;EAdN;AACF;AAiBA;EACI;IACI,uCAAA;IACA,+BAAA;EAfN;EAiBE;IACI,2CAAA;IACA,mCAAA;EAfN;EAiBE;IACI,0CAAA;IACA,kCAAA;EAfN;AACF;AAkBA;EACI;IACI,uCAAA;IACA,+BAAA;EAhBN;EAkBE;IACI,2CAAA;IACA,mCAAA;EAhBN;EAkBE;IACI,0CAAA;IACA,kCAAA;EAhBN;AACF;AAmBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,qCAAA;EACA,6BAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;AAjBJ;AAkBI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhBR;AAiBQ;EACI,mBAAA;EACA,uCAAA;EACA,sDAAA;EACA,kBAAA;EACA,aAAA;EACA,iCAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;AAfZ;AAgBY;EACI,4CAAA;AAdhB;AAgBoB;EACI,6CAAA;AAdxB;AAgB4B;EACI,aAAA;AAdhC;AAoBY;EACI,uCAAA;AAlBhB;AAoBoB;EACI,6CAAA;AAlBxB;AAoB4B;EACI,aAAA;AAlBhC;AAwBY;EACI,gDAAA;AAtBhB;AAwBoB;EACI,2CAAA;AAtBxB;AAwB4B;EACI,eAAA;AAtBhC;AA4BY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA1BhB;AA2BgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAzBpB;AA2BgB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAzBpB;AA2BgB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAzBpB;AA4BY;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AA1BhB;AA4BY;EACI,iBAAA;AA1BhB;AA2BgB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAzBpB;;AAiCA;EACI;IAAK,+BAAA;EA7BP;EA8BE;IAAO,iCAAA;EA3BT;AACF;AA6BA;EACI;IAAK,uBAAA;EA1BP;EA2BE;IAAO,yBAAA;EAxBT;AACF;AA0BA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAxBJ;AAyBI;EACI,yCAAA;EACA,kBAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,qCAAA;AAvBR;AAyBI;EACI,WAAA;EACA,YAAA;AAvBR;;AA4BA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAzBJ;AA0BI;EACI,yCAAA;EACA,kBAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,qCAAA;AAxBR;AA0BI;EACI,WAAA;EACA,YAAA;AAxBR;;AA4BA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iDAAA;EACA,kBAAA;AAzBJ;AA0BI;EACI,yCAAA;EACA,kBAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,qCAAA;AAxBR;AA0BI;EACI,WAAA;EACA,YAAA;AAxBR;;AA+BA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BJ;AA6BI;EACI,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AA3BR;AA4BQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gDAAA;AA1BZ;AA2BY;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAzBhB;AA4BgB;EACI,iCAAA;AA1BpB;AA6BY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,YAAA;EACA,SAAA;AA3BhB;AA4BgB;EACI,uBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,eAAA;AA1BpB;AA2BoB;EACI,WAAA;EACA,YAAA;AAzBxB;AA0BwB;EACI,mCAAA;EACA,UAAA;AAxB5B;AA8BQ;EACI,cAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA5BZ;AA6BY;EACI,kBAAA;EACA,yCAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AA3BhB;AA4BgB;EACI,cAAA;EACA,aAAA;AA1BpB;AA2BoB;EACI,aAAA;EACA,sBAAA;AAzBxB;AA0BwB;EACI,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,yCAAA;EACA,qCAAA;EACA,kFAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AAxB5B;AAyB4B;EACI,YAAA;EACA,SAAA;EACA,qBAAA;EACA,2BAAA;AAvBhC;AAyB4B;EACI,SAAA;EACA,UAAA;EACA,qCAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvBhC;AA4BgB;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;AA1BpB;AA4BwB;EACI,yBAAA;AA1B5B;AA6BoB;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA3BxB;AA6BoB;EACI,kBAAA;AA3BxB;AA8BgB;EACI,YAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;AA5BpB;AA6BoB;EACI,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,yCAAA;EACA,qCAAA;EACA,kFAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AA3BxB;AA4BwB;EACI,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AA1B5B;AA4BwB;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AA1B5B;AA2B4B;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAzBhC;AAmCQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AAjCZ;AAkCY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhChB;AAiCgB;EACI,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;AA/BpB;AAiCwB;EACI,mCAAA;AA/B5B;AAoCY;EACI,UAAA;EACA,uBAAA;EACA,WAAA;AAlChB;AAmCgB;EACI,yBAAA;EACA,gBAAA;AAjCpB;AAkCoB;EACI,WAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhCxB;AAiCwB;EACI,6CAAA;EACA,WAAA;EACA,WAAA;AA/B5B;AAiCwB;EACI,cAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/B5B;AAqCgC;EACI,aAAA;AAnCpC;AAqCgC;EACI,aAAA;AAnCpC;AAyCgB;EACI,eAAA;AAvCpB;;AA+CA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AA5CJ;AA6CI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qCAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qCAAA;EACA,6BAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AA3CR;AA4CQ;EACI,eAAA;AA1CZ;AA4CQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AA1CZ;AA4CgB;EACI,iCAAA;AA1CpB;AA8CQ;EACI,2BAAA;AA5CZ;;AAkDA;EACI,QAAA;EACA,YAAA;EACA,qCAAA;EACA,yCAAA;EACA,iFAAA;EACA,WAAA;EACA,gBAAA;AA/CJ;AAiDI;EACI,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,sCAAA;AA/CR;AAiDQ;EACI,+CAAA;AA/CZ;;AAqDA;EACI,MAAA;EACA,OAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;AAlDJ;AAmDI;EACI,qCAAA;EACA,YAAA;AAjDR;AAkDQ;EACI,gBAAA;EACA,YAAA;AAhDZ;AAmDY;EACI,yCAAA;EACA,yCAAA;AAjDhB;AAkDgB;EACI,YAAA;EACA,qCAAA;AAhDpB;AAiDoB;EACI,iJAAA;EACA,0GAAA;AA/CxB;AAgDwB;EACI,+GAAA;AA9C5B;AAgDwB;EACI,8CAAA;EACA,iFAAA;AA9C5B;AAgDgC;EACI,kFAAA;AA9CpC;AAmDoB;EACI,+IAAA;EACA,kGAAA;AAjDxB;AAkDwB;EACI,6GAAA;AAhD5B;AAkDwB;EACI,4CAAA;EACA,iFAAA;AAhD5B;AAkDgC;EACI,kFAAA;AAhDpC;AAwDQ;EACI,6CAAA;AAtDZ;;AA4DA;EACI,YAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAzDJ;AA0DI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAxDR;AAyDQ;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvDZ;AAyDQ;EACI,WAAA;EACA,mCAAA;AAvDZ;AA0DI;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxDR;AAyDQ;EACI,WAAA;EACA,mBAAA;AAvDZ;;AA4DI;EACI,yCAAA;AAzDR;;AA4DA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AAzDJ;AA0DI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yDAAA;EACA,kDAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAxDR;AAyDQ;EACI,cAAA;EACA,cAAA;AAvDZ;AAyDgB;EACI,aAAA;AAvDpB;AA2DQ;EACI,WAAA;EACF,4CAAA;EACM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAzDhB;AA2DQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,4CAAA;EACA,cAAA;AAzDZ;;AA+DA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AA5DJ;AA6DI;EACI,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,6BAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AA3DR;AA4DQ;EACI,iBAAA;AA1DZ;AA2DY;EACI,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAzDhB;AA2DoB;EACI,iCAAA;AAzDxB;AA8DQ;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yCAAA;AA5DZ;AA6DY;EACI,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA3DhB;AA4DgB;EACI,yCAAA;AA1DpB;AA4DgB;EACI,oBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;AA1DpB;AA4DwB;EACI,uCAAA;AA1D5B;AAgEwB;EACI,iCAAA;AA9D5B;AAoEgB;EACI,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,WAAA;EACA,iBAAA;AAlEpB;AAsEgB;EACI,yCAAA;AApEpB;AAqEoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAnExB;AAqE4B;EACI,yCAAA;EACA,UAAA;AAnEhC;AAyE4B;EACI,mCAAA;EACA,UAAA;AAvEhC;AA6EY;EACI,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA3EhB;;AAgFA;EACI,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qDAAA;EACA,yFAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AA7EJ;AA8EI;EACI,iCAAA;EACA,oCAAA;AA5ER;AA6EQ;EACI,cAAA;AA3EZ;AA8EI;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,qBAAA;AA5ER;AA6EQ;EACI,6BAAA;AA3EZ;AA8EI;EACI,eAAA;EACA,8BAAA;AA5ER;AA8EI;EACI,4CAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AA5ER;;AAiFA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AA9EJ;AA+EI;EACI,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,6BAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA7ER;AA8EQ;EACI,sBAAA;AA5EZ;AA+EoB;EACI,uCAAA;AA7ExB;AAiFY;EACI,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AA/EhB;AAiFoB;EACI,iCAAA;AA/ExB;AAoFQ;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,kBAAA;EACA,yCAAA;EACA,qCAAA;AAlFZ;AAmFY;EACI,sBAAA;AAjFhB;AAkFgB;EACI,kBAAA;EACA,qCAAA;EACA,kBAAA;AAhFpB;AAiFoB;EACI,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA/ExB;AAgFwB;EACI,cAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AA9E5B;AA+E4B,yOAAA,qBAAA;EACI,kCAAA;EACA,uBAAA;AA7EhC;AA+E4B;EACI,kCAAA;EACA,uBAAA;AA7EhC;AAiFoB;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AA/ExB;AAgFwB;EACI,iCAAA;EACA,YAAA;AA9E5B;AAiFoB;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;AA/ExB;AAgFwB;EACI,iBAAA;AA9E5B;AA+E4B;EACI,mCAAA;AA7EhC;AAmFY;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,wBAAA;AAjFhB;AAkFgB;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAhFpB","sourcesContent":["\n.container-border{\n    position: relative;\n    box-shadow : 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n}\n\ninput[disabled]{\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.aa-language-item:has(input:disabled){\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n\n.agentassist-widget-main-chat-container-wrapper{\n    height: 100%;\n    display: flex;\n    position: relative;\n    &.left-menu-nav-enable{\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        border-radius: 4px;\n        .section-agent-aa-wrapper{\n            box-shadow: none;\n        }\n    }\n    nav{\n        flex-shrink: 0;\n        border-radius: 4px 0px 0px 4px;\n        border-right: 1px solid var(--AA-gloabl-border);\n        background: var(--AA-global-white-bg);\n        display: flex;\n        padding: 11px;\n        flex-direction: column;\n        align-items: center;\n        gap: 12px;\n        width: 72px\n    }\n    .section-agent-aa-wrapper{\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        position: relative;\n        overflow: hidden;\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        header{\n            border-radius: 4px 4px 0px 0px;\n            border-bottom: 1px solid var(--AA-gloabl-border);\n            background: var(--AA-gloabl-bg-secondary);\n        }\n        .body-container-aa{\n            flex: 1 1 auto;\n            position: relative;\n            overflow: hidden;\n        }\n        footer{\n            border-radius: 0px 0px 4px 4px;\n            background: var(--AA-gloabl-bg-secondary);\n        }\n    }\n}\n\n.aa-no-tabs-screen{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    flex-direction: column;\n    padding: 0 16px;\n}\n\n@-webkit-keyframes NudgeslideInDown {\n    0% {\n        -webkit-transform: translateY(-100%);\n        transform: translateY(-100%);\n        visibility: visible;\n    }\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n}\n\n@keyframes NudgeslideInDown {\n    0% {\n        -webkit-transform: translateY(-100%);\n        transform: translateY(-100%);\n        visibility: visible;\n    }\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n}\n\n.nudges-wrapper-fixed{\n    position: absolute;\n    width: 100%;\n    height: auto;\n    z-index: 9999;\n    max-width: 418px;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    top: 40px;\n    padding: 10px 16px;\n    -webkit-animation-name: NudgeslideInDown;\n    animation-name: NudgeslideInDown;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    .nudges-template-data{\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n        .nudges-card{\n            border-radius: 24px;\n            background: var(--success-500-main, #22C55E);\n            box-shadow: 15px 15px 26px 0px rgba(0, 0, 0, 0.15);\n            display: flex;\n            align-items: center;\n            padding: 6px 16px;\n            gap: 6px;\n            &.info-nudge{\n                background: var(--AA-gloabl-border);\n                p{\n                    color: var(--AA-gloabl-text-color);\n                }\n                .close-nudge{\n                    svg{\n                        path{\n                            stroke: #000000;\n                        }\n                    }\n                }\n            }\n            &.warning-nudge{\n                background: var(--warning-500-main, #F59E0B);\n            }\n            &.danger-nudge{\n                background: var(--destructive-500-main, #EF4444);\n            }\n            .icon_block{\n                flex-shrink: 0;\n                width: 16px;\n                height: 16px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: var(--AA-global-white-color);\n                svg{\n                    path{\n                        fill:#FFFFFF;\n                    }\n                }\n            }\n            p{\n                color: var(--AA-global-white-color);\n                font-size: 14px;\n                font-weight: 500;\n                line-height: 20px;\n                margin: 0;\n                width: 100%;\n            }\n            .close-nudge{\n                width: 16px;\n                height: 16px;\n                background: transparent;\n                padding: 0;\n                border: 0;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: var(--AA-global-white-color);\n                font-size: 16px;\n                svg{\n                    path{\n                        stroke:#FFFFFF;\n                    }\n                }\n            }   \n        }\n    }\n}\n\n.widgets-disabled-card-wrapper{\n    position: absolute;\n    bottom: 0;\n    padding: 20px 10px;\n    z-index: 9;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    .widgets-info-disabled-content{\n        border-radius: 12px;\n        background: var(--Warning-500, #F79009);\n        box-shadow: 0px 25px 50px -12px rgba(16, 24, 40, 0.25);\n        display: flex;\n        padding: 12px;\n        align-items: flex-start;\n        gap: 16px;\n        .icon_block{\n            display: flex;\n            width: 24px;\n            height: 24px;\n            justify-content: center;\n            align-items: center;\n            flex-shrink: 0;\n            border-radius: 28px;\n            border: 2px solid var(--Warning-100, #FEF0C7);\n            background: var(--Base-White, #FFF);\n            color: #F79009;\n            font-size: 16px;\n        }\n        .content-info-widget{\n            width: 100%;\n            h1{\n                color: var(--Base-White, #FFF);\n                font-size: 14px;\n                font-weight: 500;\n                line-height: 20px;\n                margin: 0 0 4px 0;\n            }\n            p{\n                color: var(--Base-White, #FFF);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n                margin: 0;\n            }\n        }\n    }\n}\n\n\n\n@-webkit-keyframes HintslideInUp {\n    0% {\n        -webkit-transform: translateY(100%);\n        transform: translateY(100%);\n        visibility: visible;\n    }\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n}\n\n@keyframes HintslideInUp {\n    0% {\n        -webkit-transform: translateY(100%);\n        transform: translateY(100%);\n        visibility: visible;\n    }\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n    }\n}\n\n@-webkit-keyframes shakeHint {\n    0%,100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n    }\n    10%,30%,50%,70%,90% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0);\n    }\n    20%,40%,60%,80% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0);\n    }\n}\n\n@keyframes shakeHint {\n    0%,100% {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n    }\n    10%,30%,50%,70%,90% {\n        -webkit-transform: translate3d(-10px, 0, 0);\n        transform: translate3d(-10px, 0, 0);\n    }\n    20%,40%,60%,80% {\n        -webkit-transform: translate3d(10px, 0, 0);\n        transform: translate3d(10px, 0, 0);\n    }\n}\n\n.hints-wrapper-fixed{\n    position: absolute;\n    width: 100%;\n    height: auto;\n    z-index: 9999;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    bottom: 56px;\n    overflow: auto;\n    max-height: 80%;\n    max-width: 100%;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    -webkit-animation-name: HintslideInUp;\n    animation-name: HintslideInUp;\n    -webkit-animation-duration: 0.5s;\n    animation-duration: 0.5s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    .hints-template-data{\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        overflow: auto;\n        height: 100%;\n        max-height: 500px;\n        padding: 10px 16px;\n        .hint-card{\n            border-radius: 12px;\n            background: var(--success-600, #16A34A);\n            box-shadow: 0px 25px 50px -12px rgba(16, 24, 40, 0.25);\n            position: relative;\n            padding: 12px;\n            -webkit-animation-name: shakeHint;\n            animation-name: shakeHint;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n            animation-delay: 1s;\n            -webkit-animation-delay: 1s;\n            &.info-hint{\n                background: var(--gray-neutral-500, #6C737F);\n                .top-card-info{\n                    .icon_block{\n                        border: 2px solid var(--Neutral-200, #E5E5E5);\n                        svg{\n                            path{\n                                fill: #667085;\n                            }\n                        }\n                    }\n                }\n            }\n            &.warning-hint{\n                background: var(--warning-500, #F79009);\n                .top-card-info{\n                    .icon_block{\n                        border: 2px solid var(--Warning-100, #FEF0C7);\n                        svg{\n                            path{\n                                fill: #F79009;\n                            }\n                        }\n                    }\n                }\n            }\n            &.danger-hint{\n                background: var(--destructive-500-main, #EF4444);\n                .top-card-info{\n                    .icon_block{\n                        border: 2px solid var(--error-200, #FECDCA);\n                        svg{\n                            path{\n                                stroke: #F04438;\n                            }\n                        }\n                    }\n                }\n            }\n            .top-card-info{\n                display: flex;\n                align-items: center;\n                gap: 6px;\n                .icon_block{\n                    display: flex;\n                    width: 24px;\n                    height: 24px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 28px;\n                    border: 2px solid var(--success-100, #D1FADF);\n                    background: #FFFFFF;\n                    flex-shrink: 0;\n                    color: #039855;\n                }\n                h1{\n                    color: #FFFFFF;\n                    font-size: 14px;\n                    font-weight: 500;\n                    line-height: 20px;\n                    margin: 0;\n                    width: 100%;\n                }\n                .close-hint{\n                    flex-shrink: 0;\n                    width: 20px;\n                    height: 20px;\n                    background: transparent;\n                    padding: 0;\n                    border: 0;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    color: #FFFFFF;\n                    font-size: 20px;\n                }\n            }\n            .body-hint{\n                padding: 6px 0;\n                color: #FFFFFF;\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n                margin: 0;\n            }\n            .footer-hint{\n                text-align: right;\n                button{\n                    color: #FFFFFF;\n                    font-size: 14px;\n                    font-weight: 500;\n                    line-height: 20px;\n                    padding: 0;\n                    border: 0;\n                    background: transparent;\n                    cursor: pointer;\n                }\n            }\n        }\n    }\n}\n\n\n@-webkit-keyframes kr-spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes kr-spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.loader-progress{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    .loading-border{\n        border: 3px solid var(--AA-gloabl-border);\n        border-radius: 50%;\n        border-top: 3px solid var(--AA-global-theme-bg);\n        width: 40px;\n        height: 40px;\n        -webkit-animation: kr-spin 2s linear infinite;\n        animation: kr-spin 2s linear infinite;\n    }\n    img{\n        width: 30px;\n        height: 30px;\n    }\n}\n\n\n.loader-progress-individual{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    .loading-border{\n        border: 3px solid var(--AA-gloabl-border);\n        border-radius: 50%;\n        border-top: 3px solid var(--AA-global-theme-bg);\n        width: 24px;\n        height: 24px;\n        -webkit-animation: kr-spin 2s linear infinite;\n        animation: kr-spin 2s linear infinite;\n    }\n    img{\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.loader-progress-main {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    border: 0.5px solid var(--AA-gloabl-bg-secondary);\n    border-radius: 5px;\n    .loading-border{\n        border: 3px solid var(--AA-gloabl-border);\n        border-radius: 50%;\n        border-top: 3px solid var(--AA-global-theme-bg);\n        width: 40px;\n        height: 40px;\n        -webkit-animation: kr-spin 2s linear infinite;\n        animation: kr-spin 2s linear infinite;\n    }\n    img{\n        width: 30px;\n        height: 30px;\n    }\n}\n\n\n// Summery popup\n\n.summery-wrapper-container{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: rgba(52, 64, 84, 0.70);\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .summery-popup-data{\n        background: var(--AA-global-white-bg);\n        border-radius: 6px;\n        max-height: 100%;\n        overflow: hidden;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        max-width: 960px;\n        .title-block{\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 10px;\n            border-bottom: 1px solid var(--AA-gloabl-border);\n            h1{\n                color: var(--AA-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 600;\n                line-height: 16px;\n                width: 100%;\n            }\n            svg{\n                path{\n                    fill: var(--AA-gloabl-text-color);\n                }\n            }\n            .ai-block{\n                flex-shrink: 0;\n                display: flex;\n                align-items: center;\n                color: var(--AA-gloabl-text-color);\n                opacity: 0.6;\n                gap: 10px;\n                .close-summery{\n                    background: transparent;\n                    border: 0;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    padding: 0;\n                    width: 16px;\n                    height: 16px;\n                    font-size: 16px;\n                    color: var(--AA-gloabl-text-color);\n                    cursor: pointer;\n                    svg{\n                        width: 16px;\n                        height: 16px;\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                            fill: none;\n                        }\n                    }\n                }\n            }\n        }\n        .summary-intent-block-data-accordion{\n            flex: 1 1 auto;\n            overflow: hidden;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            .summary-intent-block-data-accordion-item{\n                border-radius: 8px;\n                border: 1px solid var(--AA-gloabl-border);\n                background: var(--AA-gloabl-bg-secondary);\n                height: 100%;\n                display: flex;\n                flex-direction: column;\n                overflow: auto;\n                max-height: 100%;\n                &.new-summary-intent{\n                    flex-shrink: 0;\n                    height: 160px;\n                    .acc-summary-content-collapse{\n                        display: flex;\n                        flex-direction: column;\n                        .text-block-summary{\n                            height: 100%;\n                            position: relative;\n                            border-radius: var(--lg, 12px);\n                            border: 1px solid var(--AA-gloabl-border);\n                            background: var(--AA-global-white-bg);\n                            box-shadow: 0px 1px 2px 0px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));\n                            display: flex;\n                            flex-direction: column;\n                            align-items: end;\n                            gap: 10px;\n                            .input-control{\n                                height: 100%;\n                                border: 0;\n                                outline: 0 !important;\n                                box-shadow: none !important;\n                            }\n                            .recylin-bin-btn{\n                                border: 0;\n                                padding: 0;\n                                background: var(--AA-global-white-bg);\n                                cursor: pointer;\n                                flex-shrink: 0;\n                                width: 36px;\n                                height: 36px;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n                            }\n                        }\n                    }\n                }\n                .acc-summary-btn{\n                    display: flex;\n                    padding: 8px;\n                    align-items: center;\n                    gap: 8px;\n                    width: 100%;\n                    background: transparent;\n                    border: 0;\n                    &[aria-expanded=\"true\"]{\n                        .summery-accordion-icon{\n                            transform: rotate(180deg);\n                        }\n                    }\n                    span{\n                        display: flex;\n                        padding: 2px 8px;\n                        justify-content: center;\n                        align-items: center;\n                        border-radius: 16px;\n                        background: var(--Primary-50, #EFF4FF);\n                        color: var(--Primary-700, #004EEB);\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 18px;\n                        flex-shrink: 0;\n                    }\n                    .summery-accordion-icon{\n                        margin: 0 0 0 auto;\n                    }\n                }\n                .acc-summary-content-collapse{\n                    padding: 8px;\n                    overflow: auto;\n                    flex: 1 1 auto;\n                    height: 100%;\n                    .summery-accordion-content{\n                        height: 100%;\n                        overflow: hidden;\n                        border-radius: var(--lg, 12px);\n                        border: 1px solid var(--AA-gloabl-border);\n                        background: var(--AA-global-white-bg);\n                        box-shadow: 0px 1px 2px 0px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));\n                        padding: var(--sm, 6px) var(--default, 8px);\n                        position: relative;\n                        display: flex;\n                        flex-direction: column;\n                        padding-right: 0;\n                        position: relative;\n                        .aa-summary-text-input-new{\n                            height: 100%;\n                            width: 100%;\n                            border: 0;\n                            padding: 0;\n                            background: transparent;\n                            resize: none;\n                            overflow: auto;\n                            color: var(--AA-gloabl-text-color);\n                            font-size: 13px;\n                            font-weight: 400;\n                            line-height: 24px;\n                            box-shadow: none;\n                            min-height: 120px;\n                        }\n                        .summery-accordion-content-inner-sec{\n                            display: flex;\n                            flex-direction: column;\n                            gap: 6px;\n                            overflow: auto;\n                            height: 100%;\n                            width: 100%;\n                            flex: 1 1 auto;\n                            position: relative;\n                            .summery-accordion-content-item{\n                                color: var(--AA-gloabl-text-color);\n                                font-size: 13px;\n                                font-weight: 400;\n                                line-height: 24px;\n                            }\n                            .summery-accordion-content-item-date-time{\n\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .actions-footer{\n            padding: 8px;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            justify-content: end;\n            position: relative;\n            min-height: 48px;\n            border-top: 1px solid var(--AA-gloabl-border);\n            .footer-btns-left-sec{\n                position: absolute;\n                z-index: 99;\n                left: 8px;\n                top: 9px;\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                .refresh-btn{\n                    border: 0;\n                    padding: 0;\n                    background: transparent;\n                    cursor: pointer;\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n            }\n            .form-feedback-info{\n                padding: 0;\n                background: transparent;\n                width: 100%;\n                .dialog-ended-and-feedback{\n                    justify-content: flex-end;\n                    min-height: 30px;\n                    .line-border-content-info{\n                        width: 100%;\n                        top: 0;\n                        display: flex;\n                        align-items: center;\n                        gap: 8px;\n                        .line-border{\n                            background: var(--AA-global-theme-text-color);\n                            width: 100%;\n                            height: 1px;\n                        }\n                        .date-time-text{\n                            flex-shrink: 0;\n                            border-radius: 16px;\n                            background: var(--AA-gloabl-bg-secondary);\n                            padding: 2px 8px;\n                            color: var(--AA-global-theme-text-color);\n                            font-size: 12px;\n                            font-weight: 400;\n                            line-height: 18px;\n                        }\n                    }\n                    .feedback-wrapper {\n                        .feedback-actions-info {\n                            .left-sec-info {\n                                .icon_block{\n                                    display: none;\n                                }\n                                h1{\n                                    display: none;\n                                }\n                            }\n                        }\n                    }\n                }\n                .improve-feedback-block{\n                    margin-top: 6px;\n                }\n            }\n        }\n    }\n}\n\n\n.interputions-slider-terminate{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    background: rgba(52, 64, 84, 0.7);\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    border-radius: 4px;\n    .interputions-canvas{\n        position: relative;\n        overflow: auto;\n        padding: 16px;\n        background: var(--AA-global-white-bg);\n        border-radius: 12px 12px 4px 4px;\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        -webkit-animation-name: HintslideInUp;\n        animation-name: HintslideInUp;\n        -webkit-animation-duration: 0.5s;\n        animation-duration: 0.5s;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        width: 100%;\n        max-height: 60vh;\n        overflow: auto;\n        .aa_btn{\n            margin-top: 6px;\n        }\n        .close-btn{\n            position: absolute;\n            width: 20px;\n            height: 20px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            right: 8px;\n            top: 12px;\n            z-index: 1;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            opacity: 0.5;\n            svg{\n                path{\n                    fill: var(--AA-gloabl-text-color);\n                }\n            }\n        }\n        .entity-mesage-data {\n            padding: 7px 0px !important;\n        }\n    }\n}\n\n\n.multiple-options-popup{\n    right: 0;\n    bottom: 50px;\n    background: var(--AA-global-white-bg);\n    border: 1px solid var(--AA-gloabl-border);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    z-index: 10;\n    min-width: 128px;\n    \n    .aa-multiple-option-item{\n        border: none;\n        background: transparent;\n        text-align: left;\n        transition: background-color 0.2s ease;\n        \n        &:hover {\n            background-color: var(--AA-gloabl-bg-secondary);\n        }\n    }\n}\n\n// Feedback Popup Styles - Constrained within aaContainer\n.feedback-popup-overlay {\n    top: 0;\n    left: 0;\n    background: rgba(52, 64, 84, 0.70);\n    backdrop-filter: blur(8px);\n    z-index: 1000;\n    .feedback-popup-container{\n        background: var(--AA-global-white-bg);\n        width: 376px;\n        .feedback-popup-close-btn {\n            background: none;\n            border: none;\n        }\n        .feedback-popup-body{\n            .feedback-popup-body-content{\n                border: 1px solid var(--AA-gloabl-border);\n                background: var(--AA-gloabl-bg-secondary);\n                .feedback-option-btn{\n                    height: 30px;\n                    background: var(--AA-global-white-bg);\n                    &.feedback-satisfied-btn{\n                        border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-components-buttons-primary-success-button-primary-success-border, #75E0A7);\n                        color: var(--component-colors-components-buttons-primary-success-button-primary-success-fg_hover, #085D3A);\n                        &:hover{\n                            background: var(--component-colors-components-buttons-primary-success-button-primary-success-bg_hover, #ECFDF3);\n                        }  \n                        &.active{\n                            background: var(--colors-success-500, #17B26A);\n                            color: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);\n                            svg{\n                                path{\n                                    stroke: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);\n                                }\n                            }\n                        }\n                    }\n                    &.feedback-unsatisfied-btn{\n                        border: var(--Border-Stroke-Default, 1px) solid var(--component-colors-components-buttons-primary-error-button-secondary-error-border, #FDA29B);\n                        color: var(--component-colors-components-buttons-primary-error-button-secondary-error-fg, #B42318);\n                        &:hover{\n                            background: var(--component-colors-components-buttons-primary-error-button-secondary-error-bg_hover, #FEF3F2);\n                        }\n                        &.active{\n                            background: var(--colors-error-500, #F04438);\n                            color: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);\n                            svg{\n                                path{\n                                    stroke: var(--component-colors-components-buttons-primary-button-primary-fg, #FFF);\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .feedback-popup-footer{\n            border-top: 1px solid var(--AA-gloabl-border);\n        }\n    }\n}\n\n\n.attachment-info-wrapper{\n    height: 100%;\n    padding: 16px 16px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    background: rgba(52, 64, 84, 0.7);\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    border-radius: 4px;\n    .attachment-header{\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        .back-btn{\n            padding: 0;\n            width: 20px;\n            flex-shrink: 0;\n            background: transparent;\n            border: 0;\n            height: 20px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n        .img-name{\n            width: 100%;\n            color: var(--AA-global-white-color);\n        }\n    }\n    .attachment-body-img{\n        flex: 1 1 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        img{\n            width: 100%;\n            object-fit: contain;\n        }\n    }\n}\n.toast-custom-msg-container.aa-network-error-toastr{\n    .toast-msg-custom{\n        background: rgb(231 130 130) !important;\n    }\n}\n.toast-custom-msg-container{\n    position: absolute;\n    width: auto;\n    height: auto;\n    z-index: 9999;\n    max-width: fit-content;\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n    display: block;\n    top: 45px;\n    padding: 10px 16px;\n    -webkit-animation-name: NudgeslideInDown;\n    animation-name: NudgeslideInDown;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    .toast-msg-custom{\n        display: flex;\n        align-items: center;\n        border-radius: 4px;\n        border: 1px solid var(--Kora-Green-Green-Medium, #93D3A2);\n        background: var(--Kora-Green-Green-Light, #EAF6EC);\n        padding: 4px 10px;\n        gap: 10px;\n        flex-shrink: 0;\n        min-height: 28px;\n        .icon_block{\n            line-height: 0;\n            flex-shrink: 0;\n            svg{\n                path{\n                    fill: #135423;\n                }\n            }\n        }\n        .toast-content-info{\n            width: 100%;\n          color: var(--Kora-Green-Green-Dark, #135423);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 18px;\n                margin: 0;\n        }\n        .close-toast-msg{\n            display: flex;\n            align-items: center;\n            width: 14px;\n            height: 14px;\n            justify-content: center;\n            padding: 0;\n            border: 0;\n            background: transparent;\n            font-size: 14px;\n            color: var(--Kora-Green-Green-Dark, #135423);\n            flex-shrink: 0;\n        }\n    }\n}\n\n\n.aa-settings-wrapper{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    background: rgba(52, 64, 84, 0.7);\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    border-radius: 4px;\n    .aa-settings-container{\n        position: relative;\n        overflow: hidden;\n        background: var(--AA-global-white-bg);\n        border-radius: 12px 12px 4px 4px;\n        display: flex;\n        flex-direction: column;\n        -webkit-animation-name: HintslideInUp;\n        animation-name: HintslideInUp;\n        -webkit-animation-duration: 0.5s;\n        animation-duration: 0.5s;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        width: 100%;\n        max-height: 80%;\n        .aa-settings-header{\n            padding: 8px 12px;\n            .aa-settings-close-btn{\n                border: 0;\n                padding: 0;\n                background: transparent;\n                line-height: 0;\n                flex-shrink: 0;\n                svg{\n                    path{\n                        fill: var(--AA-gloabl-text-color);\n                    }\n                }\n            }\n        }\n        .aa-settings-body{\n            flex: 1 1 auto;\n            height: 100%;\n            overflow: auto;\n            padding: 8px;\n            background: var(--AA-gloabl-bg-secondary);\n            .card-item{\n                padding: 10px;\n                background: var(--AA-global-white-bg);\n                border-radius: 4px;\n                cursor: pointer;\n                transition: .2s all ease;\n                &:hover{\n                    background: var(--AA-gloabl-bg-secondary);\n                }\n                .card-icon{\n                    border-radius: 200px;\n                    background: var(--Primary-50, #EAF1FC);\n                    width: 28px;\n                    height: 28px;\n                    svg{\n                        path{\n                            fill: var(--AA-global-theme-text-color);\n                        }\n                    }\n                }\n                .aa-btn-link{\n                    svg{\n                        path{\n                            fill: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n            }\n            .proactive-mode-data{\n                .card-group{\n                    border-radius: 6px;\n                    border: 1px solid var(--AA-static-border);\n                    background: var(--AA-global-white-bg);\n                    width: 100%;\n                    padding: 10px 5px;\n                }\n            }\n            .card-group-help{\n                .card-item{\n                    border: 1px solid var(--AA-static-border);\n                    .card-icon{\n                        width: 60px;\n                        height: 60px;\n                        border-radius: 4px;\n                        svg{\n                            path{\n                                stroke: var(--AA-global-theme-text-color);\n                                fill:none;\n                            }\n                        }\n                    }\n                    .aa-btn-link{\n                        svg{\n                            path{\n                                stroke: var(--AA-gloabl-text-color);\n                                fill:none;\n                            }\n                        }\n                    }\n                }\n            }\n            .language-group{\n                border: 1px solid var(--AA-static-border);\n                border-radius: 6px;\n                padding: 10px;\n                background: var(--AA-global-white-bg);\n                max-height: 100%;\n                overflow: auto;\n                display: flex;\n                flex-direction: column;\n                gap: 12px;\n            }\n        }\n    }\n}\n.generate-summary-action-minimized{\n    position: fixed;\n    z-index: 2;\n    border-radius: 60px;\n    background: var(--AAthemebgColorVariation-1, #F9FAFB);\n    box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);\n    display: flex;\n    padding: 10px;\n    align-items: flex-start;\n    gap: 2px;\n    min-width: 45px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    &:hover{\n        border-radius: 0px 60px 60px 60px;\n        background: var(--Gray-300, #D0D5DD);\n        svg{\n            display: block;\n        }\n    }\n    .svg-inner{\n        display: none;\n        position: absolute;\n        top: 0;\n        inset-inline-start: 0;\n        path{\n            stroke: var(--whiteTextColor);\n        }\n    }\n    i{\n        font-size: 18px;\n        color: var(--primaryTextColor);\n    }\n    .status-summary-indicator{\n        background: var(--warningTextColor, #F04438);\n        width: 4px;\n        height: 4px;\n        border-radius: 100%;\n        flex-shrink: 0;\n    }\n}\n\n\n.custom-tab-show-all-dialogs-popup-wrapper{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n    background: rgba(52, 64, 84, 0.7);\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    border-radius: 4px;\n    .custom-tab-show-all-dialogs-popup-container{\n        position: relative;\n        overflow: hidden;\n        background: var(--AA-global-white-bg);\n        border-radius: 12px 12px 4px 4px;\n        display: flex;\n        flex-direction: column;\n        -webkit-animation-name: HintslideInUp;\n        animation-name: HintslideInUp;\n        -webkit-animation-duration: 0.5s;\n        animation-duration: 0.5s;\n        -webkit-animation-fill-mode: both;\n        animation-fill-mode: both;\n        width: 100%;\n        height: 60%;\n        padding: 8px;\n        .custom-tab-show-all-dialogs-popup-header{\n            padding: 0 4px 4px 8px;\n            .custom-tab-show-all-dialogs-popup-header-icon{\n                svg{\n                    path{\n                        fill: var(--AA-global-theme-text-color);\n                    }\n                }\n            }\n            .custom-tab-show-all-dialogs-popup-close-btn{\n                border: 0;\n                padding: 0;\n                background: transparent;\n                line-height: 0;\n                flex-shrink: 0;\n                svg{\n                    path{\n                        fill: var(--AA-gloabl-text-color);\n                    }\n                }\n            }\n        }\n        .custom-tab-show-all-dialogs-popup-body-container{\n            flex: 1 1 auto;\n            height: 100%;\n            padding: 8px 0;\n            background: var(--AA-gloabl-bg-secondary);\n            border-radius: 6px;\n            border: 1px solid var(--AA-gloabl-border);\n            background: var(--AA-global-white-bg);\n            .custom-dialog-search-container{\n                padding: 0px 8px 0 8px;\n                .input-block{\n                    position: relative;\n                    background: var(--AA-global-white-bg);\n                    border-radius: 8px;\n                    .input-control{\n                        z-index: 1;\n                        position: relative;\n                        background: transparent;\n                        padding-right: 35px;\n                        padding-left: 35px;\n                        &.suggestion-input{\n                            display: block;\n                            width: 100%;\n                            color: var(--AA-gloabl-text-color);\n                            background: transparent;\n                            position: absolute;\n                            top: 0;\n                            left: 0;\n                            z-index: 0;\n                            &::-moz-selection { /* Code for Firefox */\n                                color: var(--AA-gloabl-text-color);\n                                background: transparent;\n                            }                  \n                            &::selection {\n                                color: var(--AA-gloabl-text-color);\n                                background: transparent;\n                            }\n                        }\n                    }\n                    svg{\n                        cursor: pointer;\n                        position: absolute;\n                        left: 12px;\n                        top: 9px;\n                        z-index: 2;\n                        path{\n                            fill: var(--AA-gloabl-text-color);\n                            opacity: 0.5;\n                        }\n                    }\n                    .clear-search{\n                        position: absolute;\n                        right: 12px;\n                        top: 8px;\n                        z-index: 2;\n                        cursor: pointer;\n                        background: border-box;\n                        border: 0;\n                        padding: 0;\n                        font-size: 16px;\n                        line-height: 0;\n                        color: var(--AA-gloabl-text-color);\n                        width: 16px;\n                        height: 16px;\n                        svg{\n                            position: initial;\n                            path{\n                                stroke: var(--AA-gloabl-text-color);\n                            }\n                        }\n                    }\n                }\n            }\n            .custom-tab-show-all-dialogs-popup-body{\n                flex: 1 1 auto;\n                height: 100%;\n                overflow: auto;\n                padding: 8px 8px 0px 8px;\n                .custom-dialog-list-container{\n                    display: flex;\n                    flex-direction: column;\n                    gap: 8px;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
